// extracted by mini-css-extract-plugin
export default {"due-amount":"LxtoVH","dueAmount":"LxtoVH"};